import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Post as PostComponent,
  TopicsSection,
  CommentThread,
  Spinner,
  FlagModal,
} from "../components/index.js";
import { LeftArrowCircleIcon } from "../assets/icons/index.js";
import topics from "../data/topics.js";
import requestHandler from "../utils/requestHandler.js";

export default function Post() {
  const navigate = useNavigate();
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingComments, setLoadingComments] = useState(false);
  const [showFlagModal, setShowFlagModal] = useState(false);

  useEffect(() => {
    const loadPost = async () => {
      setLoading(true);
      const res = await requestHandler({
        path: `posts/${postId}`,
        method: "GET",
      });

      if (res.success) {
        setPost(res.data);
      } else {
        console.error("Error loading posts:", res.error);
      }
      setLoading(false);
    };

    loadPost();
  }, [postId]);

  const handleCommentSubmit = async (content) => {
    setLoadingComments(true);
    try {
      // Submit the comment
      const res = await requestHandler({
        path: "comments",
        method: "POST",
        body: {
          content: content,
          post_id: postId,
        },
      });

      if (res.success && res.data.flagged === true) {
        setLoadingComments(false);
        setShowFlagModal(true);
        return { flagged: true };
      }

      if (res) {
        // Refetch the entire post to get the updated comments list
        const updatedPostRes = await requestHandler({
          path: `posts/${postId}`,
          method: "GET",
        });

        if (updatedPostRes.success) {
          setPost(updatedPostRes.data);
        }
      } else {
        console.error("Error posting comment");
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
    } finally {
      setLoadingComments(false);
    }
  };

  const handleTopicClick = (topicName) => {
    navigate("/community", { state: { selectedTopic: topicName } });
  };

  const handleBackToCommunity = () => {
    navigate("/community");
  };

  return (
    <>
      <FlagModal
        isOpen={showFlagModal}
        onClose={() => setShowFlagModal(false)}
      />
      <div className="flex h-[calc(100vh-4rem)] md:h-[calc(100vh-4rem)] flex-row justify-between gap-4 pb-4">
      {/* Main Post Content */}
      <div className="flex flex-col gap-4 h-full overflow-y-auto no-scrollbar w-full md:w-3/4">
        <h1 className="text-4xl uppercase text-black dark:text-lz-concrete">
          <div className="flex flex-row gap-2 items-center">
            <LeftArrowCircleIcon
              className="dark:fill-lz-concrete w-10 h-10 cursor-pointer"
              onClick={handleBackToCommunity}
            />
            Community
          </div>
        </h1>
        {loading ? (
          <Spinner />
        ) : (
          <PostComponent
            enableNavigation={false}
            isIndividualPostPage={true}
            post={post}
            onCommentSubmit={handleCommentSubmit}
          />
        )}
        {loadingComments ? (
          <div className="pl-8">
            <Spinner />
          </div>
        ) : (
          <CommentThread comments={post?.comments || []} />
        )}
      </div>
      <TopicsSection
        onTopicClick={handleTopicClick}
        topics={topics}
        className="hidden md:block"
      />
    </div>
    </>
  );
}
